 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3":"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3","CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa":"CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa","CoincidenceData~information~parameterLampList~scaling":"CoincidenceData~information~parameterLampList~scaling","CoincidenceData":"CoincidenceData","information":"information","userCenter":"userCenter","parameterLampList":"parameterLampList","administer":"administer","application":"application","auditHtml~brandPage~conformBrand~currency~custom~lampListDetails~productScreen~project~realityQuery~~94455f72":"auditHtml~brandPage~conformBrand~currency~custom~lampListDetails~productScreen~project~realityQuery~~94455f72","scaling":"scaling","auditHtml~currency~custom~selectLampList~selectLampListAll":"auditHtml~currency~custom~selectLampList~selectLampListAll","auditHtml":"auditHtml","currency":"currency","custom":"custom","selectLampList":"selectLampList","selectLampListAll":"selectLampListAll","brandPage~lampListDetails~productScreen~seriesPage":"brandPage~lampListDetails~productScreen~seriesPage","lampListDetails":"lampListDetails","brandPage":"brandPage","seriesPage":"seriesPage","testCustom":"testCustom","productScreen":"productScreen","conformBrand":"conformBrand","project~realityQuery":"project~realityQuery","project":"project","realityQuery":"realityQuery","brand":"brand","collect":"collect","datapush":"datapush","details":"details","dosageAnalysis":"dosageAnalysis","home":"home","institutionalInformation":"institutionalInformation","lampData":"lampData","login":"login","maintenance":"maintenance","noHtml5":"noHtml5","problem":"problem","product":"product","productAnalyze":"productAnalyze","productInformation":"productInformation","productScreendetails":"productScreendetails","projectType":"projectType","register":"register","release":"release","role":"role","secretPage":"secretPage","selectLampType":"selectLampType","series":"series","single":"single","supplierInPage":"supplierInPage","test":"test","user":"user","virtual":"virtual"}[chunkId]||chunkId) + "." + {"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3":"99fdba9a","CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa":"14fe8925","CoincidenceData~information~parameterLampList~scaling":"398dd577","CoincidenceData":"183fb472","information":"54516789","userCenter":"387d7ed8","parameterLampList":"4d14e844","administer":"bc2017b9","application":"02c65676","auditHtml~brandPage~conformBrand~currency~custom~lampListDetails~productScreen~project~realityQuery~~94455f72":"28498cc2","scaling":"95eaba82","auditHtml~currency~custom~selectLampList~selectLampListAll":"e520c815","auditHtml":"d46c1726","currency":"4849c719","custom":"0f701cc8","selectLampList":"e72ee029","selectLampListAll":"c97c9bec","brandPage~lampListDetails~productScreen~seriesPage":"0dcc805e","lampListDetails":"33380e89","brandPage":"fc2cea29","seriesPage":"562a1389","testCustom":"996d84bb","productScreen":"18c5e8ca","conformBrand":"0ad024bf","project~realityQuery":"9b8c9283","project":"e3ea3ffa","realityQuery":"79fd90fd","brand":"ff3ee419","collect":"1fdcb99a","datapush":"2b6abf32","details":"51849e68","dosageAnalysis":"f2261acb","home":"1e1aec48","institutionalInformation":"84a64044","lampData":"ad17d0cf","login":"ea62460a","maintenance":"d321c4d9","noHtml5":"cc17af27","problem":"56ff34c4","product":"07caf122","productAnalyze":"a70f9790","productInformation":"91ad742d","productScreendetails":"0c980156","projectType":"25a76926","register":"4ad67871","release":"4e1efe31","role":"7d55d251","secretPage":"0b20ea8d","selectLampType":"da1f5a10","series":"5085b06b","single":"bf630e89","supplierInPage":"b3321627","test":"8fb561b1","user":"335a0290","virtual":"4dc39b3d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3":1,"CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa":1,"CoincidenceData~information~parameterLampList~scaling":1,"CoincidenceData":1,"information":1,"userCenter":1,"parameterLampList":1,"application":1,"scaling":1,"auditHtml~currency~custom~selectLampList~selectLampListAll":1,"auditHtml":1,"currency":1,"custom":1,"selectLampList":1,"selectLampListAll":1,"brandPage~lampListDetails~productScreen~seriesPage":1,"lampListDetails":1,"brandPage":1,"seriesPage":1,"testCustom":1,"productScreen":1,"conformBrand":1,"project~realityQuery":1,"project":1,"brand":1,"collect":1,"datapush":1,"details":1,"dosageAnalysis":1,"home":1,"institutionalInformation":1,"lampData":1,"login":1,"maintenance":1,"noHtml5":1,"problem":1,"product":1,"productAnalyze":1,"productInformation":1,"productScreendetails":1,"projectType":1,"register":1,"release":1,"role":1,"selectLampType":1,"series":1,"single":1,"supplierInPage":1,"user":1,"virtual":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3":"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3","CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa":"CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa","CoincidenceData~information~parameterLampList~scaling":"CoincidenceData~information~parameterLampList~scaling","CoincidenceData":"CoincidenceData","information":"information","userCenter":"userCenter","parameterLampList":"parameterLampList","administer":"administer","application":"application","auditHtml~brandPage~conformBrand~currency~custom~lampListDetails~productScreen~project~realityQuery~~94455f72":"auditHtml~brandPage~conformBrand~currency~custom~lampListDetails~productScreen~project~realityQuery~~94455f72","scaling":"scaling","auditHtml~currency~custom~selectLampList~selectLampListAll":"auditHtml~currency~custom~selectLampList~selectLampListAll","auditHtml":"auditHtml","currency":"currency","custom":"custom","selectLampList":"selectLampList","selectLampListAll":"selectLampListAll","brandPage~lampListDetails~productScreen~seriesPage":"brandPage~lampListDetails~productScreen~seriesPage","lampListDetails":"lampListDetails","brandPage":"brandPage","seriesPage":"seriesPage","testCustom":"testCustom","productScreen":"productScreen","conformBrand":"conformBrand","project~realityQuery":"project~realityQuery","project":"project","realityQuery":"realityQuery","brand":"brand","collect":"collect","datapush":"datapush","details":"details","dosageAnalysis":"dosageAnalysis","home":"home","institutionalInformation":"institutionalInformation","lampData":"lampData","login":"login","maintenance":"maintenance","noHtml5":"noHtml5","problem":"problem","product":"product","productAnalyze":"productAnalyze","productInformation":"productInformation","productScreendetails":"productScreendetails","projectType":"projectType","register":"register","release":"release","role":"role","secretPage":"secretPage","selectLampType":"selectLampType","series":"series","single":"single","supplierInPage":"supplierInPage","test":"test","user":"user","virtual":"virtual"}[chunkId]||chunkId) + "." + {"CoincidenceData~auditHtml~brandPage~currency~custom~information~lampListDetails~scaling~selectLampLi~23c956e3":"0dafae59","CoincidenceData~auditHtml~currency~custom~information~lampListDetails~scaling~selectLampList~selectL~5a399baa":"5f56f92f","CoincidenceData~information~parameterLampList~scaling":"9aa91f9f","CoincidenceData":"79a73639","information":"5724c62e","userCenter":"5629ee72","parameterLampList":"496abc94","administer":"31d6cfe0","application":"5d569af7","auditHtml~brandPage~conformBrand~currency~custom~lampListDetails~productScreen~project~realityQuery~~94455f72":"31d6cfe0","scaling":"23c4b6d3","auditHtml~currency~custom~selectLampList~selectLampListAll":"bc09e6ab","auditHtml":"922f4766","currency":"1528bfe7","custom":"9c920d06","selectLampList":"63d66dd9","selectLampListAll":"6d8ce267","brandPage~lampListDetails~productScreen~seriesPage":"37a18870","lampListDetails":"1bc8df28","brandPage":"f5fc4972","seriesPage":"2e1f0482","testCustom":"1890a6f0","productScreen":"c8c91927","conformBrand":"9942c368","project~realityQuery":"24ee20f8","project":"6bee9e3b","realityQuery":"31d6cfe0","brand":"c234bc14","collect":"148b58c8","datapush":"0e9eca6d","details":"ccece4e3","dosageAnalysis":"06d73d20","home":"3633261d","institutionalInformation":"70be2d7c","lampData":"1abc99b1","login":"87d27108","maintenance":"683d832b","noHtml5":"8f1bde12","problem":"aa980819","product":"d80c3a4f","productAnalyze":"0134a959","productInformation":"94e3b8a8","productScreendetails":"9361fc30","projectType":"20f69d72","register":"ea49719f","release":"1e126150","role":"d4e6a81c","secretPage":"31d6cfe0","selectLampType":"4a89ca33","series":"0677d353","single":"0992bfe2","supplierInPage":"6c67de93","test":"31d6cfe0","user":"0cd6702c","virtual":"33d5a1c3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
